import { ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import { Box, useTheme } from '@mui/material';
import { SelectComponent, SelectOption } from '../../core/SelectComponent/SelectComponent';
import { ExportMenuComponent } from '../ExportMenuComponent/ExportMenuComponent';
import { reportHeaderStyles } from './ReportHeaderComponent.styles';

type GridCellComponent = 
  | ReactElement<typeof SelectComponent>
  | ReactElement<typeof ExportMenuComponent>
  | null
  | undefined;

interface ReportHeaderComponentProps {
  rows: number;
  columns: number;
  components: GridCellComponent[][];
}

export const ReportHeaderComponent = ({
  rows,
  columns,
  components,
}: ReportHeaderComponentProps) => {
  const theme = useTheme();

  return (
    <Box sx={reportHeaderStyles.container(theme)}>
      <Grid container spacing={2}>
        {Array.from({ length: rows }).map((_, rowIndex) =>
          Array.from({ length: columns }).map((_, colIndex) => {
            const component = components[rowIndex]?.[colIndex];
            return (
              <Grid key={`${rowIndex}-${colIndex}`} size={{ xs: 12 / columns }} sx={reportHeaderStyles.gridCell(theme)}>
                {component || null}
              </Grid>
            );
          })
        )}
      </Grid>
    </Box>
  );
};

export default ReportHeaderComponent;
